import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Signup from "./pages/SignUp";
import Login from "./pages/Login";
import ThreeDModel from "./pages/ThreeDModel";
import CaseList from "./pages/CaseList";
import CasesPage from "./pages/CasesPage";
import ProfilePage from "./pages/ProfilePage";
import AddOrEditCasePage from "./pages/AddOrEditCasePage";
// import SettingsPage from "./pages/SettingsPage";
import ContactPage from "./pages/ContactPage";
import NotFound from "./pages/NotFound";
//import UnderMaintenance from "./pages/UnderMaintenance";
import Footer from "./components/common/Footer";

function App() {
  const isSignedIn = useSelector((state) => state.user.isSignedIn);
  const location = useLocation();
  const hideFooter =
    location.pathname.startsWith("/model") || location.pathname === "/contact";

  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex-grow pt-16">
        <Routes>
          <Route
            path="/"
            element={isSignedIn ? <CaseList /> : <Navigate to="/login" />}
          />
          <Route
            path="/home"
            element={isSignedIn ? <CaseList /> : <Navigate to="/login" />}
          />
          <Route
            path="/signup"
            element={isSignedIn ? <Navigate to="/caselist" /> : <Signup />}
          />
          <Route
            path="/login"
            element={isSignedIn ? <Navigate to="/caselist" /> : <Login />}
          />
          <Route path="/case/:id" element={<CasesPage />} />
          <Route
            path="/caselist"
            element={isSignedIn ? <CaseList /> : <Navigate to="/login" />}
          />
          <Route
            path="/profilepage"
            element={isSignedIn ? <ProfilePage /> : <Navigate to="/login" />}
          />
          <Route
            path="/addoreditcasepage"
            element={
              isSignedIn ? <AddOrEditCasePage /> : <Navigate to="/login" />
            }
          />
          <Route
            path="/model/:id"
            element={isSignedIn ? <ThreeDModel /> : <Navigate to="/login" />}
          />
          {/* <Route
            path="/settings"
            element={isSignedIn ? <SettingsPage /> : <Navigate to="/login" />}
          /> */}
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      {!hideFooter && <Footer />}
    </div>
  );
}

export default App;
